<template>
    <!--查看日志，华为云弹性文件服务也调用了该页面-->
    <Modal v-model="modal"
           width="700"
           :title="$t('查看日志')"
           class="logModal"
           :mask-closable="false"
           footer-hide
           @on-cancel="cancel">
        <div v-show="!noLogs">
            <log :data="logs" />
        </div>
        <div v-show="noLogs">
            <div class="no-log">{{$t('暂无日志')}}</div>
        </div>
    </Modal>
</template>

<script>
import log from '../log'
export default {
    name: 'logModal',
    components: {
        log
    },
    data () {
        return {
            modal: false,
            logs: [],
            noLogs: false
        }
    },
    methods: {
        openModal (url) {
            this.axios.get(this.urlFormat(url, true)).then(res => {
                this.logs = res
                if (!res || res.length < 1) {
                    this.noLogs = true
                } else {
                    this.noLogs = false
                }
            })
            this.modal = true
        },
        cancel () {
            this.modal = false
        }
    }
}
</script>

<style lang="less">
.logModal {
    .ivu-modal-body {
        padding: 0px;
        overflow: auto;
        max-height: 450px;
    }
    .ivu-modal-header {
        background: #242424;
        border-bottom: 1px solid #383737;
        .ivu-modal-header-inner {
            color: #fff;
        }
    }
}
</style>
<style lang="less" scoped>
.logModal {
    .no-log {
        font-size: 18px;
        font-weight: bold;
        font-family: "DejaVu Sans Mono";
        background-color: #000;
        color: #ccc;
        line-height: 300px;
        text-align: center;
        font-size: 20px;
    }
}
</style>
